export const styles = {
  halfDayRowCheckedCombined: 'DailyClockIn_halfDayRow DailyClockIn_halfDayRowChecked',
  halfDayRowUncheckedCombined: 'DailyClockIn_halfDayRow DailyClockIn_halfDayRowUnchecked',
  checkboxCheckedCombined: 'DailyClockIn_checkbox DailyClockIn_checkboxChecked',
  checkboxUncheckedCombined: 'DailyClockIn_checkbox DailyClockIn_checkboxUnchecked',
} as const
